import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { defaultMarkdownParser } from './parsers'
import { TextWrapper } from './Components'

/**
 * Markdown.
 *
 * Transform normal text to markdown text.
 *
 * @param {Object} props - Component Props.
 * @param [{string}] props.className - Style class for the markdown text wrapper.
 * @param {string} props.children - String with the text marked.
 * @param {string} props.parser - Parser to be used.
 *
 * @returns {React.ReactElement} - React element.
 *
 * @example // Basic example
 * <Markdown>"Hello I am `Normal Text` but I will markdown :smile:"</Markdown>
 */
const Markdown = ({ className, children, parser }) => {
  const markdown = useMemo(() => {
    return parser(children)
  }, [children, parser])

  return <TextWrapper className={className}>{markdown}</TextWrapper>
}

Markdown.defaultProps = {
  children: '',
  parser: defaultMarkdownParser,
}

Markdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  parser: PropTypes.func,
}

export default Markdown
